export default
{
	"stats": {
		"average_engagement_duration": 41.7532083755488,
		"total_users": 151393,
		"total_new_users": 21929,
		"total_events": 176296
	},
	"total_users_by_month": {
		"2023-05-01": 12598,
		"2024-02-01": 14811,
		"2023-07-01": 12798,
		"2023-08-01": 15470,
		"2024-03-01": 12690,
		"2023-11-01": 10129,
		"2023-06-01": 13220,
		"2023-10-01": 12765,
		"2023-12-01": 8707,
		"2024-01-01": 14265,
		"2023-09-01": 11591,
		"2023-04-01": 10257,
		"2023-03-01": 2092
	},
	"new_users_by_month": {
		"2023-05-01": 1658,
		"2024-02-01": 2266,
		"2023-07-01": 1729,
		"2023-08-01": 2103,
		"2024-03-01": 1936,
		"2023-11-01": 1534,
		"2023-06-01": 1736,
		"2023-10-01": 2068,
		"2023-12-01": 1403,
		"2024-01-01": 2220,
		"2023-09-01": 1653,
		"2023-04-01": 1334,
		"2023-03-01": 289
	},
	"events_by_month": {
		"2023-05-01": 14918,
		"2024-02-01": 17022,
		"2023-07-01": 15250,
		"2023-08-01": 17955,
		"2024-03-01": 14588,
		"2023-11-01": 11800,
		"2023-06-01": 15759,
		"2023-10-01": 14558,
		"2023-12-01": 9891,
		"2024-01-01": 16489,
		"2023-09-01": 13440,
		"2023-04-01": 12137,
		"2023-03-01": 2489
	},
	"sessions_by_channel_group": {
		"Organic Search": 112525,
		"Unassigned": 1821,
		"Direct": 36188,
		"Organic Video": 678,
		"Display": 585,
		"Referral": 2678,
		"Paid Search": 44,
		"Organic Social": 611
	},
	"views_by_page": {
		"Bellaire TX | NexGenEsis Healthcare": 1627,
		"Honolulu HI | NexGenEsis Healthcare": 7755,
		"NexGenEsis Healthcare Clinics": 21871,
		"Treatment Methods | NexGenEsis Healthcare": 2231,
		"Phoenix AZ | NexGenEsis Healthcare": 1301,
		"Testimonials | NexGenEsis Healthcare": 3192,
		"Services | NexGenEsis Healthcare": 3997,
		"Peripheral Neuropathy | NexGenEsis Healthcare": 1478,
		"Locations | NexGenEsis Healthcare": 4478,
		"The Woodlands TX | NexGenEsis Healthcare": 989,
		"Peripheral Neuorpathy | NexGenEsis Healthcare": 843,
		"Who We Are | NexGenEsis Healthcare": 2610,
		"Joint Therapies | NexGenEsis Healthcare": 1489,
		"New Patients | NexGenEsis Healthcare": 1604,
		"San Antonio TX | NexGenEsis Healthcare": 317,
		"General information | NexGenEsis Healthcare": 848,
		"Knee Discomfort | NexGenEsis Healthcare": 1182,
		"Knee Issues | NexGenEsis Healthcare": 714,
		"Nexgenesis Aesthetics Clinics": 125,
		"Medical Financing | NexGenEsis Healthcare": 417,
		"Back Discomfort | NexGenEsis Healthcare": 578,
		"Gilbert AZ | NexGenEsis Healthcare": 794,
		"Baton Rouge LA | NexGenEsis Healthcare": 1079,
		"Midland TX | NexGenEsis Healthcare": 598,
		"Shoulder Discomfort | NexGenEsis Healthcare": 340,
		"Weight Management | NexGenEsis Healthcare": 304,
		"Gulport MS | NexGenEsis Healthcare": 1254,
		"In the News | NexGenEsis Healthcare": 254,
		"Mission Statement | NexGenEsis Healthcare": 200,
		"Hip Discomfort | NexGenEsis Healthcare": 230,
		"Arthritis Issues | NexGenEsis Healthcare": 148,
		"Back Issues | NexGenEsis Healthcare": 191,
		"Shoulder Issues | NexGenEsis Healthcare": 141,
		"Ankle Discomfort | NexGenEsis Healthcare": 119,
		"Free Phone Consultation | NexGenEsis Healthcare": 373,
		"Neck Discomfort | NexGenEsis Healthcare": 189,
		"Wrist Discomfort | NexGenEsis Healthcare": 92,
		"Clearwater FL | NexGenEsis Healthcare": 112,
		"NexGenEsis Aesthetics Clinics": 24,
		"Hair Restoration | NexGenEsis Healthcare": 53,
		"Hip Issues | NexGenEsis Healthcare": 126,
		"Neck Issues | NexGenEsis Healthcare": 93,
		"Sports Injuries | NexGenEsis Healthcare": 39,
		"West Chester PA | NexGenEsis Healthcare": 30,
		"Hattiesburg MS | NexGenEsis Healthcare": 40,
		"Providers | NexGenEsis Healthcare": 98,
		"Waco TX | NexGenEsis Healthcare": 23,
		"Services | Nexgenesis Aesthetics Clinics": 3,
		"Gulport MS | Nexgenesis Aesthetics Clinics": 3,
		"Baton Rouge LA | Nexgenesis Aesthetics Clinics": 2,
		"Bellaire TX | NexGenEsis Aesthetics Clinics": 2,
		"Clearwater FL | Nexgenesis Aesthetics Clinics": 2,
		"Gilbert AZ | Nexgenesis Aesthetics Clinics": 2,
		"Honolulu HI | Nexgenesis Aesthetics Clinics": 2,
		"Locations | Nexgenesis Aesthetics Clinics": 2,
		"Midland TX | Nexgenesis Aesthetics Clinics": 2,
		"Phoenix AZ | Nexgenesis Aesthetics Clinics": 2,
		"The Woodlands TX | Nexgenesis Aesthetics Clinics": 2,
		"Toledo OH | NexGenEsis Healthcare": 24,
		"General Information | NexGenEsis Healthcare": 1,
		"Gilbert AZ | NexGenEsis Aesthetics Clinics": 1,
		"Services | NexGenEsis Aesthetics Clinics": 4,
		"Jackson MS | NexGenEsis Healthcare": 1,
		"(1) NexGenEsis Healthcare Clinics": 3,
		"Locations | NexGenEsis Aesthetics Clinics": 1,
		"お客様の声 | ネクスジェネシス ヘルスケア": 1,
		"​​​​​NexGenEsis Healthcare Clinics": 1,
		"(1) Back Discomfort | NexGenEsis Healthcare": 1,
		"(1) Honolulu HI | NexGenEsis Healthcare": 1
	},
	"total_users_by_location": {
		"United States": 147481,
		"China": 212,
		"Guam": 31,
		"India": 628,
		"United Kingdom": 54,
		"(not set)": 85,
		"Netherlands": 66,
		"French Polynesia": 39,
		"Germany": 667,
		"Guatemala": 23,
		"Philippines": 130,
		"Singapore": 15,
		"Mexico": 519,
		"Indonesia": 508,
		"Ireland": 195,
		"Sweden": 10,
		"Australia": 45,
		"Canada": 119,
		"Ecuador": 10,
		"Russia": 6,
		"American Samoa": 10,
		"Bangladesh": 45,
		"Belize": 5,
		"Bermuda": 9,
		"Brazil": 39,
		"Denmark": 3,
		"Dominican Republic": 5,
		"Greece": 7,
		"Hong Kong": 27,
		"Italy": 3,
		"Japan": 54,
		"Kenya": 3,
		"Lithuania": 3,
		"Malaysia": 6,
		"Marshall Islands": 3,
		"Moldova": 3,
		"New Zealand": 25,
		"Nicaragua": 5,
		"Romania": 37,
		"Saudi Arabia": 15,
		"Seychelles": 6,
		"Spain": 9,
		"Taiwan": 11,
		"Trinidad & Tobago": 4,
		"United Arab Emirates": 15,
		"Venezuela": 8,
		"France": 81,
		"Hungary": 4,
		"Nigeria": 3,
		"Ghana": 13,
		"Türkiye": 4,
		"Belgium": 8,
		"Pakistan": 21,
		"Thailand": 4,
		"Colombia": 4,
		"Norway": 3,
		"Congo - Brazzaville": 4,
		"Czechia": 4,
		"South Korea": 6,
		"South Africa": 4,
		"Morocco": 5,
		"Egypt": 3,
		"Switzerland": 3,
		"Vietnam": 8,
		"Finland": 8
	}
}